import store from "@/store";
export default async function authMiddleware(to, from, next) {
  const publicRoutes = ["Login", "RecoverPassword"];

  if (store.state.authChecking) {
    await new Promise((resolve) => {
      const unwatch = store.watch(
        (state) => state.authChecking,
        (checking) => {
          if (!checking) {
            unwatch();
            resolve();
          }
        }
      );
    });
  }

  const isAuthenticated = !!store.state.user;
  const currentUser = store.state.user;
  
  if (isAuthenticated && publicRoutes.includes(to.name)) {
    return next({ name: "Home" });
  }
  if (publicRoutes.includes(to.name)) {
    return next();
  }
  if (!isAuthenticated) {
    return next({ name: "Login" });
  }
  
  // Check admin requirement (admin, owner and superadmin can manage users)
  if (to.meta.requiresAdmin && (!currentUser || !['admin', 'owner', 'superadmin'].includes(currentUser.role))) {
    return next({ name: "Home" }); // Redirect to home if not admin
  }
  
  // Check owner requirement (owner and superadmin see all companies)
  if (to.meta.requiresOwner && (!currentUser || !['owner', 'superadmin'].includes(currentUser.role))) {
    return next({ name: "Home" }); // Redirect to home if not owner/superadmin
  }

  // Check superadmin requirement
  if (to.meta.requiresSuperAdmin && (!currentUser || currentUser.role !== 'superadmin')) {
    return next({ name: "Home" }); // Redirect to home if not superadmin
  }
  
  next();
}


